import { render, staticRenderFns } from "./PointHandle.vue?vue&type=template&id=6ac0b9df&"
import script from "./PointHandle.vue?vue&type=script&lang=ts&"
export * from "./PointHandle.vue?vue&type=script&lang=ts&"
import style0 from "./PointHandle.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports